import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { TasksService } from '@/services/tasks.service'
import { UploadFormService } from '@/services/uploadForm.service'

import { STATUS, STEP_TYPE } from '@/constants/common'
import { TStatus } from '@/types/task.interface'

import { DraftsContext } from '../components/shotlistUpload/DraftsContext'

interface IUseUploadFileItemOpenParams {
	taskId: string
	draftStatus: TStatus
	isUploading: boolean
	setActiveUploading: (taskId: string) => void
	setIsModalOpen: (value: boolean) => void
	setSelectedWay: (value: STEP_TYPE) => void
	setOpenFormModal: (value: boolean) => void
	clearItem: (taskId: string) => void
}

export const useUploadFileItemOpen = ({
	taskId,
	draftStatus,
	isUploading,
	setActiveUploading,
	setIsModalOpen,
	setSelectedWay,
	setOpenFormModal,
	clearItem
}: IUseUploadFileItemOpenParams) => {
	const navigate = useNavigate()
	const { removeDraft } = useContext(DraftsContext)

	const handleItemClick = async () => {
		try {
			const shotlist = await TasksService.getTask(taskId)

			if (shotlist && !shotlist.has_video && !isUploading) {
				setActiveUploading(taskId)
				setIsModalOpen(true)
				return
			}

			const form = await UploadFormService.getFormData(taskId)

			if (shotlist && form && form.is_completed === false) {
				setActiveUploading(taskId)
				setIsModalOpen(true)
				setSelectedWay(STEP_TYPE.UPLOAD)
				setOpenFormModal(true)
				return
			}
		} catch (error) {
			if (error?.response?.status === 404) {
				if (draftStatus === STATUS.FINISHED) {
					navigate(`/file/${taskId}`)
					clearItem(taskId)
					removeDraft(taskId)
				}
				return
			}

			console.log(error)
		}
	}

	return {
		handleItemClick
	}
}
